import React from 'react';

const PreviewLayout: React.FunctionComponent<React.PropsWithChildren> = ({
  children,
}) => <div className="preview-layout">{children}</div>;

export default PreviewLayout;
